"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1977],{

/***/ 99433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14759);

/* harmony default export */ __webpack_exports__["Z"] = ({
    poster: "/static/img/tags/video_image.png",
    videoId: "l-7awVpecvU",
    fitToParent: false,
    playButtonColor: "iris",
    playButtonSize: _constants__WEBPACK_IMPORTED_MODULE_0__.MD,
    showShadow: true
});


/***/ }),

/***/ 86199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ youtube_video_with_poster_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/youtube-video/youtube-video-component.js + 1 modules
var youtube_video_component = __webpack_require__(14831);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/youtube-video-with-poster/youtube-video-with-poster-component.scss.js


var StyledYoutubeVideoWithPosterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yvzfjg0"
})("display:flex;flex-direction:column;align-items:center;position:relative;cursor:pointer;.poster-image-wrapper{top:0;left:0;transition:opacity 0.1s ease-out;opacity:1;&.with-shadow{box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);}img{width:100%;height:100%;object-fit:cover;}}.video-component-wrapper{opacity:0;iframe{display:block;}}&:hover{.play-button-container{transform:translate(-50%,-50%) scale(1.1);}}.play-button-container{border:none;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:80px;height:80px;border-radius:50%;background-color:", colors/* default.white */.Z.white, ";box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);pointer-events:none;transition:transform 0.2s ease-in-out;.play-button{box-sizing:border-box;border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-left-color:rgb(51,51,51);border-style:solid;border-width:16px 0 16px 28px;position:absolute;left:calc(50% + 4px);top:50%;transform:translate(-50%,-50%);}&.lg{width:128px;height:128px;.play-button{border-width:24px 0 24px 36px;left:calc(50% + 8px);}}}&.hide-poster{.poster-image-wrapper{opacity:0;z-index:-1;}.video-component-wrapper{opacity:1;z-index:1;}}");

// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/constants.js
var constants = __webpack_require__(14759);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/default-props.js
var default_props = __webpack_require__(99433);
;// CONCATENATED MODULE: ./components/core/youtube-video-with-poster/youtube-video-with-poster-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}









var YOUTUBE_ASPECT_RATIO = 9 / 16;
var YoutubeVideoWithPosterComponent = function(props) {
    var ref = (0,react.useState)(true), isPosterVisible = ref[0], setIsPosterVisible = ref[1];
    var ref1 = (0,react.useState)(false), playVideo = ref1[0], setPlayVideo = ref1[1];
    var ref2 = (0,react.useRef)(null);
    var width = props.width, fitToParent = props.fitToParent, playButtonColor = props.playButtonColor, poster = props.poster, previewRenderer = props.previewRenderer, alt = props.alt, playButtonSize = props.playButtonSize, translate = props.translate, showShadow = props.showShadow, videoId = props.videoId, muted = props.muted, volume = props.volume, videoOpts = props.videoOpts;
    var onPlayButtonClicked = function(e) {
        setIsPosterVisible(false);
        setPlayVideo(true);
    };
    var getInlineStyle = function() {
        var _ref_current;
        var styleWidth = (_ref_current = ref2.current) === null || _ref_current === void 0 ? void 0 : _ref_current.offsetWidth;
        if (fitToParent && styleWidth) {
            return {
                width: styleWidth,
                height: styleWidth * YOUTUBE_ASPECT_RATIO
            };
        }
        return {
            height: "auto",
            width: width
        };
    };
    var getButtonContainerStyle = function() {
        var _buttonThemes_playButtonColor;
        if (!playButtonColor) return {};
        return {
            backgroundColor: (_buttonThemes_playButtonColor = constants/* buttonThemes */.l[playButtonColor]) === null || _buttonThemes_playButtonColor === void 0 ? void 0 : _buttonThemes_playButtonColor.color
        };
    };
    var getButtonArrowStyle = function() {
        var _buttonThemes_playButtonColor;
        if (!playButtonColor) return {};
        return {
            borderLeftColor: (_buttonThemes_playButtonColor = constants/* buttonThemes */.l[playButtonColor]) === null || _buttonThemes_playButtonColor === void 0 ? void 0 : _buttonThemes_playButtonColor.background
        };
    };
    var renderPreview = function() {
        if (previewRenderer) {
            return isPosterVisible && previewRenderer();
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("poster-image-wrapper", {
                "with-shadow": showShadow
            }),
            style: {
                display: isPosterVisible ? "block" : "none"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: classnames_default()("play-button-container", playButtonSize),
                    style: getButtonContainerStyle(),
                    "aria-label": translate("accessibility.button.playVideo"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "play-button",
                        style: getButtonArrowStyle()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    pictureClass: "poster-image",
                    alt: alt,
                    src: poster,
                    screenRatios: {
                        mobile: 0.99,
                        mobileRetina: 0.99
                    }
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledYoutubeVideoWithPosterComponent, {
        className: classnames_default()("youtube-video-with-poster-component", {
            "hide-poster": !isPosterVisible
        }),
        onClick: onPlayButtonClicked,
        ref: ref2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "video-component-wrapper",
                style: {
                    display: isPosterVisible ? "none" : "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_component/* default */.ZP, {
                    videoId: videoId,
                    playing: playVideo,
                    muted: muted,
                    volume: volume,
                    opts: _object_spread({}, getInlineStyle(), videoOpts),
                    showShadow: showShadow
                })
            }),
            renderPreview()
        ]
    });
};
/* harmony default export */ var youtube_video_with_poster_component = ((0,generic_config_context/* withGenericConfig */.P)(YoutubeVideoWithPosterComponent));
YoutubeVideoWithPosterComponent.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 11977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ EmbeddedYoutubeAssetComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/youtube-video-with-poster-component.js + 1 modules
var youtube_video_with_poster_component = __webpack_require__(86199);
// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/default-props.js
var default_props = __webpack_require__(99433);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/embedded-youtube-asset/embedded-youtube-asset-component.scss.js


var StyledEmbeddedYoutubeAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejtaqz50"
})("margin:auto;&:not(.full-width){max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/embedded-youtube-asset/embedded-youtube-asset-component.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var EmbeddedYoutubeAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(EmbeddedYoutubeAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(EmbeddedYoutubeAssetComponent);
    function EmbeddedYoutubeAssetComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, EmbeddedYoutubeAssetComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getStyle", function() {
            var _props = _this.props, width = _props.width, mobileWidth = _props.mobileWidth, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser;
            var finalWidth = isMobileOrTabletBrowser && mobileWidth ? mobileWidth : width;
            finalWidth = finalWidth || "auto";
            return {
                width: finalWidth
            };
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(EmbeddedYoutubeAssetComponent, [
        {
            key: "render",
            value: function render() {
                var fullWidth = this.props.fullWidth;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEmbeddedYoutubeAssetComponent, {
                    className: classnames_default()("embedded-youtube-asset-component", {
                        "full-width": fullWidth
                    }),
                    style: this.getStyle(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_with_poster_component/* default */.Z, _object_spread_props(_object_spread({}, this.props), {
                        fitToParent: true
                    }))
                });
            }
        }
    ]);
    return EmbeddedYoutubeAssetComponent;
}(react.PureComponent);

EmbeddedYoutubeAssetComponent.defaultProps = _object_spread({}, default_props/* default */.Z);


/***/ })

}]);